<template>
  <div>
    <ReLinkingItemList
        :items="items"
        heading="calculator.reLinking.popularAmounts"
    />
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';
import { mapState } from 'vuex';

import ReLinkingItemList from '@/components/Calculator/ReLinking/ReLinkingItemList.vue';
import UrlGenerator from '@/services/calculatorUrlGenerator';

export default {
  name: 'PopularAmounts',
  components: { ReLinkingItemList },
  data () {
    return {
      popularAmounts: [10, 100, 1000, 5000, 15000, 50000],
    };
  },
  computed: {
    ...mapState('calculator', ['selectedCryptoCurrency', 'selectedFiatCurrency', 'usdAggregatePrice']),
    items () {
      return this.popularAmounts.map((fiatAmount) => {
        const cryptoAmount = this.calculatePopularAmount(new BigNumber(fiatAmount));
        return {
          link: UrlGenerator.cryptoToFiatWithAmount(
            this.selectedCryptoCurrency.code,
            this.selectedFiatCurrency.code,
            cryptoAmount,
            this.$i18n.locale,
          ),
          title: {
            path: 'calculator.pageTitle.cryptoToFiatWithAmount',
            args: {
              cryptoAmount,
              cryptoCode: this.selectedCryptoCurrency.code,
              fiatCode: this.selectedFiatCurrency.code,
            },
          },
        };
      });
    },
  },
  methods: {
    calculatePopularAmount (amount) {
      if (this.usdAggregatePrice === null) {
        return '0';
      }
      const cryptoAmount = amount.dividedBy(this.usdAggregatePrice);
      if (cryptoAmount.isGreaterThan(1)) {
        return this.roundFirstDigit(cryptoAmount);
      }
      if (cryptoAmount.isEqualTo(0)) {
        return '0';
      }

      return this.roundFirstSignificantDecimalDigit(cryptoAmount);
    },
    roundFirstSignificantDecimalDigit (amount) {
      const amountDecimals = amount.toString().split('.')[1];
      let digitIndex = 0;
      let zerosString = '';
      while (amountDecimals[digitIndex] === '0') {
        zerosString += '0';
        digitIndex++;
      }
      const firstDigit = this.getRoundedFirstDigit(new BigNumber(amountDecimals));
      const amountString = `0.${zerosString}${firstDigit}`;
      if (firstDigit === 10) {
        return amountString * 10;
      }

      return amountString;
    },
    roundFirstDigit (amount) {
      const amountString = Math.trunc(amount.toString()).toString();
      const numberOfZeros = amountString.length - 1;
      const firstDigit = this.getRoundedFirstDigit(amount);
      let zerosString = '';

      while (zerosString.length < numberOfZeros) {
        zerosString += '0';
      }

      return `${firstDigit}${zerosString}`;
    },
    getRoundedFirstDigit (amount) {
      const [firstDigit, secondDigit] = amount.toString()
        .split('')
        .filter((element) => ['.', ','].indexOf(element) === -1);
      const combinedNumber = `${firstDigit}.${secondDigit || '0'}`;
      if (combinedNumber >= 7.5) {
        return 10;
      }
      if (combinedNumber >= 2.5) {
        return 5;
      }

      return 1;
    },
  },
};
</script>
